

export default function FormatComponentName(compName) {
  let formattedName = "Component Type not found";
  if(compName) {
    formattedName = compName.split("-").join(" ").replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase())));
  } 
  
  return formattedName;
}